
/* dw-rejuva-parity-runtime-20260619 start */
(function(){
  function fmtDate(){var d=new Date();return d.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});} 
  function apply(){var root=document.getElementById('back-support-sale-native')||document.getElementById('back-support-sale-native')||document;var box=root.querySelector('#cc-id-Hr8nB7RcXoqN'); if(box) box.textContent='Without surgery. Without drugs. Without injections.'; var ship=root.querySelector('#cc-id-CjydRAezQwKR'); if(ship){ship.src='//daywick.com/cdn/shop/t/13/assets/daywick-clean-icon-09-20260612.svg';ship.removeAttribute('srcset');ship.alt='US free shipping icon';}
    var sticky=root.querySelector('#fkt-link-e3b-289-a69'); if(sticky){var parts=fmtDate().replace(',','').split(' ');var md=(parts[0]||'Jun')+' '+(parts[1]||'19');var yr=parts[2]||'2026';sticky.innerHTML='<h1 id="ih8j6go"><span id="cc-id-BbyGv8m43DLK">GET 56% OFF TODAY ONLY!</span></h1><p id="irzbvnu"><span id="cc-id-j9ff2I9to7WJ">Sale Ends Today,<br><span id="today-date"><span style="color:#cc0000;">'+md+'</span>, '+yr+'</span></span></p>';}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply);else apply();setTimeout(apply,500);setTimeout(apply,1500);
})();
/* dw-rejuva-parity-runtime-20260619 end */
(function(){
  var root=document.getElementById('back-support-sale-native');
  if(!root) return;
  var defaultVariant='54336893288794';
  var offer=document.getElementById('cc-id-Jdm2X8SGztwK');
  function textOf(el){return ((el.getAttribute('data-text-value')||'')+' '+(el.textContent||'')+' '+(el.getAttribute('title')||'')).toLowerCase();}
  function selectorVariant(name){
    var box=root.querySelector('.daywick-size-selector[data-daywick-size-selector="'+name+'"]');
    var active=box && box.querySelector('.daywick-size-option.is-active');
    return (active && active.getAttribute('data-variant-id')) || defaultVariant;
  }
  function setActive(btn){
    var box=btn.closest('.daywick-size-selector');
    if(!box) return;
    box.querySelectorAll('.daywick-size-option').forEach(function(b){b.classList.toggle('is-active', b===btn);});
  }
  function checkout(btn){
    var qty=btn && (btn.getAttribute('data-checkout-qty') || (btn.getAttribute('data-offers')==='18801' ? '2' : '1'));
    if(qty==='2'){
      var first=selectorVariant('bundle-1');
      var second=selectorVariant('bundle-2');
      window.location.href = first===second ? '/cart/'+first+':2?checkout' : '/cart/'+first+':1,'+second+':1?checkout';
      return;
    }
    window.location.href='/cart/'+selectorVariant('single')+':1?checkout';
  }
  function setFaqHeight(item){
    var ans=item && item.querySelector('.faq-answer');
    if(!ans) return;
    ans.style.height=item.classList.contains('active') ? ans.scrollHeight+'px' : '0px';
  }
  root.querySelectorAll('.faq-item').forEach(function(item){ setFaqHeight(item); });
  window.addEventListener('resize',function(){root.querySelectorAll('.faq-item.active').forEach(setFaqHeight);});
  root.addEventListener('click',function(e){
    var sizeBtn=e.target.closest && e.target.closest('.daywick-size-option');
    if(sizeBtn && root.contains(sizeBtn)){
      e.preventDefault();
      setActive(sizeBtn);
      return;
    }
    var q=e.target.closest && e.target.closest('.faq-question');
    if(q && root.contains(q)){
      e.preventDefault();
      var item=q.closest('.faq-item');
      root.querySelectorAll('.faq-item').forEach(function(other){ if(other!==item){ other.classList.remove('active'); setFaqHeight(other); } });
      item.classList.toggle('active');
      setFaqHeight(item);
      return;
    }
    var el=e.target.closest && e.target.closest('a,button');
    if(!el || !root.contains(el)) return;
    if(el.classList.contains('addToCart') || el.getAttribute('data-checkout-qty')){
      e.preventDefault();
      checkout(el);
      return;
    }
    var txt=textOf(el);
    if(txt.indexOf('try')>-1 || txt.indexOf('buy now')>-1 || txt.indexOf('order now')>-1 || txt.indexOf('56%')>-1 || txt.indexOf('today only')>-1){
      e.preventDefault();
      if(offer) offer.scrollIntoView({behavior:'smooth',block:'start'}); else window.location.href='/cart/'+defaultVariant+':1?checkout';
    }
  },true);
})();

/* Sticky CTA toggle - modeled on source HTB sales bridge JS */
(function(){
  var root=document.getElementById("back-support-sale-native");
  if(!root)return;
  var sticky=root.querySelector("#ij0v4x-3.fk-row.sticky, .fk-row.sticky");
  if(!sticky)return;
  function updateSticky(){
    var scrolled=window.scrollY||document.documentElement.scrollTop||0;
    var show=scrolled>900;
    if(show){
      sticky.style.setProperty("visibility","visible","important");
      sticky.style.setProperty("opacity","1","important");
      sticky.style.setProperty("transform","translateY(0)","important");
      sticky.style.setProperty("pointer-events","auto","important");
      sticky.style.setProperty("display","flex","important");
    }else{
      sticky.style.setProperty("visibility","hidden","important");
      sticky.style.setProperty("opacity","0","important");
      sticky.style.setProperty("transform","translateY(110%)","important");
      sticky.style.setProperty("pointer-events","none","important");
      sticky.style.setProperty("display","flex","important");
    }
  }
  window.addEventListener("scroll",updateSticky,{passive:true});
  window.addEventListener("resize",updateSticky);
  updateSticky();
  setTimeout(updateSticky,350);
})();

/* Inject CSS overrides at runtime to bypass CDN cache */
(function(){
  var style=document.createElement("style");
  style.id="daywick-lumbar-sales-runtime-overrides";
  style.textContent=[
    "#back-support-sale-native #ij0v4x-3.fk-row.sticky{position:fixed!important;left:0!important;right:0!important;bottom:0!important;top:auto!important;width:100%!important;max-width:100%!important;margin:0!important;z-index:999999!important;background:#fff!important;box-shadow:0 -2px 10px rgba(0,0,0,.1)!important;padding:8px 12px!important;display:flex!important;justify-content:center!important;align-items:center!important;}",
    "#back-support-sale-native #ij0v4x-3.fk-row.sticky a{display:block!important;max-width:534px!important;margin:0 auto!important;background:#47901a!important;color:#fff!important;text-decoration:none!important;font-family:Montserrat,Arial,sans-serif!important;font-size:22px!important;line-height:28px!important;font-weight:700!important;padding:12px 24px!important;text-align:center!important;border-radius:4px!important;}"
  ].join("\n");
  document.head.appendChild(style);
})();

/* daywick-baresupport-faq-source-behavior-20260619 start */
(function(){
  var root=document.getElementById('back-support-sale-native');
  if(!root || root.__daywickFaqSourceBehavior20260619) return;
  root.__daywickFaqSourceBehavior20260619=true;
  function setAnswer(item, open){
    var ans=item && item.querySelector('.faq-answer');
    if(!ans) return;
    var icon=item.querySelector('.faq-icon');
    if(open){
      item.classList.add('active');
      ans.style.setProperty('display','block','important');
      ans.style.setProperty('height','auto','important');
      ans.style.setProperty('max-height', Math.max(ans.scrollHeight, 220)+'px','important');
      ans.style.setProperty('opacity','1','important');
      ans.style.setProperty('overflow','hidden','important');
      if(icon) icon.textContent='−';
    }else{
      item.classList.remove('active');
      ans.style.setProperty('display','block','important');
      ans.style.setProperty('height','auto','important');
      ans.style.setProperty('max-height','0px','important');
      ans.style.setProperty('opacity','0','important');
      ans.style.setProperty('overflow','hidden','important');
      if(icon) icon.textContent='+';
    }
    if(icon){icon.style.setProperty('transform','none','important');icon.style.setProperty('color','#05A5D5','important');icon.style.setProperty('background','transparent','important');}
  }
  function init(){
    root.querySelectorAll('.faq-item').forEach(function(item){setAnswer(item,false);});
    root.querySelectorAll('.faq-question').forEach(function(q){
      if(q.__daywickFaqClick20260619) return;
      q.__daywickFaqClick20260619=true;
      q.addEventListener('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var item=q.closest('.faq-item');
        var willOpen=item && !item.classList.contains('active');
        root.querySelectorAll('.faq-item').forEach(function(other){setAnswer(other,false);});
        if(item && willOpen) setAnswer(item,true);
      },true);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  window.addEventListener('resize',function(){root.querySelectorAll('.faq-item.active').forEach(function(item){setAnswer(item,true);});});
})();
/* daywick-baresupport-faq-source-behavior-20260619 end */

/* daywick-baresupport-faq-source-behavior-20260619-v2 start */
(function(){
  var root=document.getElementById('back-support-sale-native');
  if(!root || root.__daywickFaqSourceBehavior20260619v2) return;
  root.__daywickFaqSourceBehavior20260619v2=true;
  function setAnswer(item, open){
    var ans=item && item.querySelector('.faq-answer');
    if(!ans) return;
    var icon=item.querySelector('.faq-icon');
    if(open){
      item.classList.add('active');
      ans.style.setProperty('display','block','important');
      ans.style.setProperty('height','auto','important');
      ans.style.setProperty('max-height', Math.max(ans.scrollHeight, 220)+'px','important');
      ans.style.setProperty('opacity','1','important');
      ans.style.setProperty('overflow','hidden','important');
      if(icon) icon.textContent='−';
    }else{
      item.classList.remove('active');
      ans.style.setProperty('display','block','important');
      ans.style.setProperty('height','auto','important');
      ans.style.setProperty('max-height','0px','important');
      ans.style.setProperty('opacity','0','important');
      ans.style.setProperty('overflow','hidden','important');
      if(icon) icon.textContent='+';
    }
    if(icon){icon.style.setProperty('transform','none','important');icon.style.setProperty('color','#05A5D5','important');icon.style.setProperty('background','transparent','important');}
  }
  function init(){root.querySelectorAll('.faq-item').forEach(function(item){setAnswer(item,false);});}
  function handle(e){
    var q=e.target.closest && e.target.closest('.faq-question');
    if(!q || !root.contains(q)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var item=q.closest('.faq-item');
    var willOpen=item && !item.classList.contains('active');
    root.querySelectorAll('.faq-item').forEach(function(other){setAnswer(other,false);});
    if(item && willOpen) setAnswer(item,true);
    return false;
  }
  root.addEventListener('click', handle, true);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  window.addEventListener('resize',function(){root.querySelectorAll('.faq-item.active').forEach(function(item){setAnswer(item,true);});});
})();
/* daywick-baresupport-faq-source-behavior-20260619-v2 end */
/* dw-live-original-sales-js-fix-20260619 start */
(function(){function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn();}
ready(function(){var root=document.getElementById('back-support-sale-native');if(!root)return;
var ssl=[].slice.call(root.querySelectorAll('*')).filter(function(e){return /SSL encryption|checkout information/i.test(e.textContent||'');})[0];if(ssl)ssl.textContent='We use 256-bit encryption, the same security standard used by banks and military organizations. Your data is 100% safe.';
var ship=document.getElementById('cc-id-CjydRAezQwKR');if(ship){ship.src='//daywick.com/cdn/shop/t/13/assets/daywick-clean-icon-09-20260612.svg';ship.setAttribute('src','//daywick.com/cdn/shop/t/13/assets/daywick-clean-icon-09-20260612.svg');ship.alt='US free shipping icon';ship.removeAttribute('srcset');}
function setAnswer(item,open){var ans=item&&item.querySelector('.faq-answer');if(!ans)return;var icon=item.querySelector('.faq-icon');if(open){item.classList.add('active');ans.style.setProperty('display','block','important');ans.style.setProperty('height','auto','important');ans.style.setProperty('max-height',Math.max(ans.scrollHeight,220)+'px','important');ans.style.setProperty('opacity','1','important');ans.style.setProperty('overflow','hidden','important');if(icon)icon.textContent='−';}else{item.classList.remove('active');ans.style.setProperty('display','block','important');ans.style.setProperty('height','auto','important');ans.style.setProperty('max-height','0px','important');ans.style.setProperty('opacity','0','important');ans.style.setProperty('overflow','hidden','important');if(icon)icon.textContent='+';}if(icon){icon.style.setProperty('transform','none','important');icon.style.setProperty('color','#05A5D5','important');icon.style.setProperty('background','transparent','important');}}
root.querySelectorAll('.faq-item').forEach(function(item){setAnswer(item,false);});root.addEventListener('click',function(e){var q=e.target.closest&&e.target.closest('.faq-question');if(!q||!root.contains(q))return;e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();var item=q.closest('.faq-item');var open=item&&!item.classList.contains('active');root.querySelectorAll('.faq-item').forEach(function(o){setAnswer(o,false);});if(item&&open)setAnswer(item,true);return false;},true);
});})();
/* dw-live-original-sales-js-fix-20260619 end */


/* dw-mikke-sales-final-runtime-fix-20260620 start */
(function(){function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn();}ready(function(){var root=document.getElementById('back-support-sale-native');if(!root)return;['cc-id-CjydRAezQwKR','cc-id-WxuQb38MRXBL'].forEach(function(id){var img=document.getElementById(id);if(!img)return;img.src='//daywick.com/cdn/shop/t/13/assets/daywick-clean-icon-09-20260612.svg';img.alt='US free shipping icon';img.removeAttribute('srcset');});root.querySelectorAll('button.addToCart img').forEach(function(img){img.style.setProperty('display','none','important');});root.querySelectorAll('.daywick-size-label,.daywick-bundle-size-heading').forEach(function(el){el.style.setProperty('color','#111','important');});root.querySelectorAll('.faq-answer').forEach(function(ans){ans.style.maxHeight='0px';ans.style.opacity='0';});root.addEventListener('click',function(e){var q=e.target.closest&&e.target.closest('.faq-question');if(!q||!root.contains(q))return;e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();var item=q.closest('.faq-item');if(!item)return false;var open=!item.classList.contains('active');root.querySelectorAll('.faq-item').forEach(function(other){other.classList.remove('active');var a=other.querySelector('.faq-answer');if(a){a.style.maxHeight='0px';a.style.opacity='0';}var i=other.querySelector('.faq-icon');if(i)i.textContent='+';});if(open){item.classList.add('active');var ans=item.querySelector('.faq-answer');if(ans){ans.style.maxHeight=Math.max(ans.scrollHeight,260)+'px';ans.style.opacity='1';}var icon=item.querySelector('.faq-icon');if(icon)icon.textContent='−';}return false;},true);});})();
/* dw-mikke-sales-final-runtime-fix-20260620 end */


/* dw-mikke-correction-icons-faq-runtime-20260620 start */
(function(){function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn();}ready(function(){var root=document.getElementById('back-support-sale-native');if(!root)return;var iconMap={
  'cc-id-WxuQb38MRXBL':'daywick-clean-icon-01-20260612.svg',
  'cc-id-CjydRAezQwKR':'daywick-clean-icon-09-20260612.svg',
  'cc-id-bTXx4EBt3Ek6':'daywick-clean-icon-04-20260612.svg'
};Object.keys(iconMap).forEach(function(id){var img=document.getElementById(id);if(!img)return;img.src='//daywick.com/cdn/shop/t/13/assets/'+iconMap[id];img.removeAttribute('srcset');});root.querySelectorAll('button.addToCart img').forEach(function(img){img.style.setProperty('display','none','important');});function close(item){item.classList.remove('active');var ans=item.querySelector('.faq-answer');if(ans){ans.style.maxHeight='0px';ans.style.opacity='0';}var icon=item.querySelector('.faq-icon');if(icon)icon.textContent='+';}function open(item){item.classList.add('active');var ans=item.querySelector('.faq-answer');if(ans){ans.style.maxHeight=Math.max(ans.scrollHeight,260)+'px';ans.style.opacity='1';}var icon=item.querySelector('.faq-icon');if(icon)icon.textContent='−';}root.querySelectorAll('.faq-item').forEach(close);root.addEventListener('click',function(e){var q=e.target.closest&&e.target.closest('.faq-question');if(!q||!root.contains(q))return;e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();var item=q.closest('.faq-item');if(!item)return false;var willOpen=!item.classList.contains('active');root.querySelectorAll('.faq-item').forEach(close);if(willOpen)open(item);return false;},true);});})();
/* dw-mikke-correction-icons-faq-runtime-20260620 end */


/* dw-baresupport-final-faq-runtime-20260620 start */
(function(){
  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn); else fn(); }
  function rootOf(el){ return el && (el.closest('#back-support-sale-native') || document.getElementById('back-support-sale-native')); }
  function answer(item){ return item && item.querySelector('.faq-answer'); }
  function icon(item){ return item && item.querySelector('.faq-icon'); }
  function close(item){
    var ans=answer(item), ic=icon(item); if(!ans) return;
    item.classList.remove('active');
    ans.style.setProperty('display','block','important');
    ans.style.setProperty('height','auto','important');
    ans.style.setProperty('max-height','0px','important');
    ans.style.setProperty('opacity','0','important');
    ans.style.setProperty('overflow','hidden','important');
    ans.style.setProperty('padding-top','0px','important');
    ans.style.setProperty('padding-bottom','0px','important');
    if(ic) ic.textContent='+';
  }
  function open(item){
    var ans=answer(item), ic=icon(item); if(!ans) return;
    item.classList.add('active');
    ans.style.setProperty('display','block','important');
    ans.style.setProperty('height','auto','important');
    ans.style.setProperty('max-height', Math.max(ans.scrollHeight + 80, 320)+'px','important');
    ans.style.setProperty('opacity','1','important');
    ans.style.setProperty('overflow','hidden','important');
    ans.style.removeProperty('padding-top');
    ans.style.removeProperty('padding-bottom');
    if(ic) ic.textContent='−';
  }
  function init(){
    var root=document.getElementById('back-support-sale-native'); if(!root) return;
    root.querySelectorAll('.faq-item').forEach(close);
  }
  ready(init);
  document.addEventListener('click', function(e){
    var q=e.target.closest && e.target.closest('#back-support-sale-native .faq-question');
    if(!q) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var root=rootOf(q), item=q.closest('.faq-item');
    if(!root || !item) return false;
    var willOpen=!item.classList.contains('active');
    root.querySelectorAll('.faq-item').forEach(close);
    if(willOpen) open(item);
    return false;
  }, true);
  window.addEventListener('resize', function(){
    var root=document.getElementById('back-support-sale-native'); if(!root) return;
    root.querySelectorAll('.faq-item.active').forEach(open);
  });
})();
/* dw-baresupport-final-faq-runtime-20260620 end */
